import { Controller } from 'stimulus'

/**
 * @class RadioSubmitController
 * @extends Controllers
 */
export default class extends Controller {
  /**
   * @function RadioSubmitController.submit
   * @param {event} event
   * @fires 'full-app:next'
   */
  submit(event) {
    event.currentTarget.dispatchEvent(new CustomEvent('full-app:next'))
  }
}
